var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M3 2h5M2 3h1m5 0h1M1 4h1m7 0h1M1 5h1m2 0h2m1 0h3M1 6h1m2 0h1m1 0h1m1 0h2M1 7h1m3 0h1m1 0h1m1 0h1M1 8h1m3 0h1m1 0h1m1 0h1M2 9h1m2 0h3m1 0h1m-7 1h3m1 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9b9a8e",
    d: "M3 3h1M2 4h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#939284",
    d: "M4 3h1M2 5h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#898879",
    d: "M5 3h1M3 4h1M2 6h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "gray",
    d: "M6 3h2M4 4h5M3 5h1m2 0h1M3 6h1M2 7h3M2 8h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    d: "M5 6h1m1 0h1M6 7h1M6 8h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#75777f",
    d: "M8 7h1M4 8h1M3 9h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6a6b73",
    d: "M8 8h1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#606168",
    d: "M4 9h1m3 0h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmy);
export default __webpack_public_path__ + "static/media/army.201b303ded352201e4b081e54b476d7e.svg";
export { ForwardRef as ReactComponent };